import ConfirmModalNoButton from 'components/common/ConfirmModalNoButton'
import NotificationError from 'components/common/notificationsErrors'
import { treasuryAccountsValidationRulesFormFields } from 'constants/crudsConfig/crudTreasuryAccountsValidationRulesConstants/crudTreasuryAccountsValidationRulesFormFields'
import { FormRefsContext } from 'context/FormRefsContext'
import { Form, Formik } from 'formik'
import { getInitValues, getValidationSchema } from 'lib/FieldValidations'
import { ICrudCompleteFields } from 'models/CrudInterface'
import React, { Component, Fragment } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { WithTranslation, withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import CrudTreasuryAcountsValidationRulesField from './treasuryAccountsValidationRulesDataFields'

interface CrudTreasuryAcountsValidationRulesProps extends WithTranslation {
	// Tipos requeridos de las Props del componente
	itemInfo?: any
	fields: Array<ICrudCompleteFields>
	disableForm: boolean
	handleSubmit: (param: any) => void
	setFormChanged: (formChanged: boolean) => void
	t: any
	method: string
	handleCloseModal: () => void
	showWarning: boolean
	handleWarning: (value: any, action: string) => void
}

interface CrudTreasuryAcountsValidationRulesState {
	// Tipos requeridos de los estados del componente
}

class CrudTreasuryAcountsValidationRules extends Component<CrudTreasuryAcountsValidationRulesProps> {
	constructor(props: CrudTreasuryAcountsValidationRulesProps) {
		super(props)
		this.state = {
			// Definicion de estado
		}
	}

	componentDidMount = () => {
		// funciones del ciclo de vida
	}

	render() {
		const {
			itemInfo,
			fields,
			disableForm,
			t,
			handleSubmit,
			setFormChanged,
			method,
			handleCloseModal,
			showWarning,
			handleWarning
		} = this.props

		const initialValues =
			itemInfo || (fields.length ? getInitValues(fields) : {}) // valores iniciales tomados de la API de campos

		const columnsCancel = disableForm ? 12 : 6 // no tocar
		const validationSchema = fields.length
			? getValidationSchema(fields, t, [], [])
			: {} // no tocar

		return (
			<FormRefsContext.Consumer>
				{({ formRef, cancelButtonRef }) => (
					<Formik
						ref={formRef}
						initialValues={initialValues}
						onSubmit={(values, actions) => {
							handleSubmit(values)
						}}
						enableReinitialize={true}
						validationSchema={validationSchema}
					>
						{(props) => (
							<Fragment>
								<Col sm={12}>
									<NotificationError
										errors={props.errors}
										touched={props.touched}
									/>
								</Col>
								<Form
									onChange={(e) => {
										setFormChanged(true)
									}}
								>
									<Row>
										{(method === 'add' ||
											((method === 'edit' || method === 'view') && itemInfo)) &&
											_.map(fields, (field) => {
												const selectedFieldConfig =
													treasuryAccountsValidationRulesFormFields.find(
														(fieldConfig) => {
															// constante de configuración de campos, punto 3
															return fieldConfig.id === field.idCampo
														}
													)
												return (
													<Col
														className={
															(selectedFieldConfig &&
																selectedFieldConfig.height) ||
															'col-sm-12'
														}
													>
														<CrudTreasuryAcountsValidationRulesField
															key={field.idCampo}
															formikProps={props}
															field={field}
															crudProps={{
																...this.props
															}}
															initialValue={
																initialValues[
																	field.idCampo as keyof typeof initialValues
																]
															}
														/>
													</Col>
												)
											})}
									</Row>
									<Row className={'pt-3'}>
										{!disableForm && (
											<Col sm={6} className={'text-center mt-2'}>
												<Button style={{ minWidth: '145px' }} type={'submit'}>
													{t('Collection.form.buttons.accept')}
												</Button>
											</Col>
										)}
										<Col sm={columnsCancel} className={'text-center mt-2'}>
											<Button
												style={{ minWidth: '145px' }}
												type={'button'}
												onClick={handleCloseModal}
												ref={cancelButtonRef}
											>
												{t('Collection.form.buttons.cancel')}
											</Button>
										</Col>
									</Row>
									<ConfirmModalNoButton // boton de confirmación para salir
										modalTitle={t('CRUDS.modal.title_warning')}
										messageBody={t('CRUDS.modal.message_changes')}
										showModal={showWarning}
										handleCloseModal={() => handleWarning(false, 'close')}
										handleCancelButton={() => {
											handleWarning(false, 'cancel')
										}}
										handleSubmitButton={(e: any) => {
											props.handleSubmit(e)
											handleWarning(false, 'submit')
										}}
									/>
								</Form>
							</Fragment>
						)}
					</Formik>
				)}
			</FormRefsContext.Consumer>
		)
	}
}

// Seteo de estados globales
// const mapStateToProps = ({ tableCalls }: any) => {
// 	const {} = tableCalls
// 	return {}
// }

// const connectForm = connect(mapStateToProps, {
// 	// Funciones adicionales de la API como por ejemplo dropdowns
// })(CrudTreasuryAcountsValidationRules)

export default withTranslation()(withRouter(CrudTreasuryAcountsValidationRules))
